import React from "react";
import InsSubmissionsDataExportGridBase from "./insSubmissionsDataExportGridBase";
import { moduleName, reducers, apiMiddleware, apiReducers, apiReducersPath, defineTokenGetter } from "components/campaigns";
import { createReducerRegistry } from "components/high-order-components/insComponentWithSlice";
defineTokenGetter((state) => state.auth?.oidc?.user?.access_token);
const InsSubmissionsDataExportGrid = () => {
    const EnhancedWithCampaigns = createReducerRegistry([
        { key: moduleName, name: "Campaigns", reducer: reducers },
        { key: apiReducersPath, middleware: apiMiddleware, name: "Campaigns API", reducer: apiReducers }
    ]);
    return React.createElement(EnhancedWithCampaigns, null,
        React.createElement(InsSubmissionsDataExportGridBase, null));
};
export default InsSubmissionsDataExportGrid;
